"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.QUESTION_STATUSES = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _QuizHelper = _interopRequireDefault(require("../QuizHelper"));

var QUESTION_STATUSES = {
  UNANSWERED: 'unanswered',
  CORRECT: 'correct',
  INCORRECT: 'incorrect'
};
exports.QUESTION_STATUSES = QUESTION_STATUSES;

var QuestionStatus = /*#__PURE__*/function () {
  function QuestionStatus(multipleAnswersAllowed, reachablePoints, text) {
    (0, _classCallCheck2["default"])(this, QuestionStatus);
    this.allowMultipleAnswers = multipleAnswersAllowed;
    this.answers = [];
    this.status = QUESTION_STATUSES.UNANSWERED;
    this.reachablePoints = reachablePoints;
    this.startedReadingQuestion = undefined;
    this.text = text;
  }

  (0, _createClass2["default"])(QuestionStatus, [{
    key: "unsetChecksIfNonMultipleAllowed",
    value: function unsetChecksIfNonMultipleAllowed() {
      if (!this.allowMultipleAnswers) {
        (0, _values["default"])(this.answers).forEach(function (answer) {
          // noinspection Eslint (reason: directly modifying the parent object)
          answer.answerChecked = false; // eslint-disable-line
        });
      }
    }
  }, {
    key: "resetQuestion",
    value: function resetQuestion() {
      this.status = QUESTION_STATUSES.UNANSWERED;
      this.startedReadingQuestion = undefined;
      this.pauseBegin = undefined;
      this.pauseTime = 0;
      this.timeToRead = undefined;
      (0, _values["default"])(this.answers).forEach(function (answer) {
        // noinspection Eslint (reason: directly modifying the parent object)
        answer.answerChecked = false; // eslint-disable-line
      });
    }
  }, {
    key: "shuffleAnswers",
    value: function shuffleAnswers() {
      this.answers = _QuizHelper["default"].shuffleArray(this.answers);
    }
  }, {
    key: "setAnswered",
    value: function setAnswered() {
      var _this = this;

      this.status = QUESTION_STATUSES.CORRECT;
      var answered = false;
      (0, _values["default"])(this.answers).forEach(function (answer) {
        if (answer.answerChecked !== answer.correct) {
          _this.status = QUESTION_STATUSES.INCORRECT;
        }

        if (answer.answerChecked) {
          answered = true;
        }
      });
      return [this.status === QUESTION_STATUSES.CORRECT, answered];
    }
  }, {
    key: "setPauseBegin",
    value: function setPauseBegin() {
      console.log('setting pause');
      this.pauseBegin = new Date();
    }
  }, {
    key: "setPauseEnd",
    value: function setPauseEnd() {
      this.pauseTime += (new Date() - this.pauseBegin) / 1000;
      console.log("pause Time: ".concat(this.pauseTime));
    }
  }, {
    key: "setStartReadingQuestion",
    value: function setStartReadingQuestion() {
      this.startedReadingQuestion = new Date();
    }
  }, {
    key: "setStopReadingQuestion",
    value: function setStopReadingQuestion() {
      var stoppedReadingQuestion = new Date();
      this.timeToRead = (stoppedReadingQuestion - this.startedReadingQuestion) / 1000 - this.pauseTime;
    }
  }]);
  return QuestionStatus;
}();

exports["default"] = QuestionStatus;